import { route } from './route';

export const portalRoutes = {
    account: {
        // /account itself renders blank until it is built; account links point at the tab that works.
        communication: () => route('/(customer)/account/communication'),
        contactPreferences: () => route('/(customer)/account/contact-preferences')
    },
    statements: () => route('/(customer)/view-statements'),
    // Served outside the (customer) group, but it is where the portal layout sends a gated obligor.
    notices: () => route('/notices'),

    payments: {
        list: () => route('/(customer)/payments'),
        create: () => route('/(customer)/payments/new'),
        history: () => route('/(customer)/payments/history'),

        methods: {
            list: () => route('/(customer)/payments/methods'),
            creditCard: () => route('/(customer)/payments/methods/credit-card'),
            bankAccount: () => route('/(customer)/payments/methods/bank-account')
        }
    },

    autopay: {
        overview: () => route('/(customer)/autopay'),
        setup: () => route('/(customer)/autopay/setup'),
        edit: (autopayId: number) => route('/(customer)/autopay/[autopayId]/edit', { autopayId: String(autopayId) })
    }
};
